import { getExpectedDayType } from './program-type.utils';
/**
 * Resolve the day type for a user on a calendar date.
 * Override wins when present; otherwise falls back to the program pattern.
 */
export function getEffectiveDayType(programType, date, override, options) {
    if (override === 'loss' || override === 'maintenance' || override === 'reward') {
        return override;
    }
    return getExpectedDayType(programType, date, options?.weekStartsOn);
}
const DATE_RE = /^(\d{4})-(\d{2})-(\d{2})$/;
/** Parse YYYY-MM-DD as a local calendar Date (midnight local). */
export function parseLocalDateString(dateStr) {
    const match = DATE_RE.exec(dateStr);
    if (!match) {
        return null;
    }
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    if (month < 1 || month > 12 || day < 1 || day > 31) {
        return null;
    }
    const date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year ||
        date.getMonth() !== month - 1 ||
        date.getDate() !== day) {
        return null;
    }
    return date;
}
/** Format a Date as YYYY-MM-DD in local calendar terms. */
export function formatLocalDateString(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
}
/**
 * Clients may change yesterday, today, or any future local calendar day.
 * `clientTodayStr` is the client's local "today" (YYYY-MM-DD); if omitted, uses server local today.
 */
export function isDayTypeOverrideDateAllowed(dateStr, clientTodayStr) {
    const target = parseLocalDateString(dateStr);
    if (!target) {
        return false;
    }
    const today = clientTodayStr
        ? parseLocalDateString(clientTodayStr)
        : parseLocalDateString(formatLocalDateString(new Date()));
    if (!today) {
        return false;
    }
    const yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
    return target.getTime() >= yesterday.getTime();
}
export function isDayGoal(value) {
    return value === 'loss' || value === 'maintenance' || value === 'reward';
}
